// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"dc9cef32","51":"dc9cef32","320":"1ed0ee5a"}[chunkId] + ".chunk.css";
};